<template>
  <!-- <StatusBar /> -->
  <router-view class="pb-24" v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <keep-alive include="DictionaryView">
        <component :is="Component" />
      </keep-alive>
    </transition>
  </router-view>
  <TabBar v-if="isAuthenticated" />
</template>

<script>
import StatusBar from '@/components/shared/StatusBar.vue'
import TabBar from '@/components/shared/TabBar.vue'
import { authService } from '@/services/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    StatusBar,
    TabBar
  },
  computed: {
    ...mapGetters(['getIsAuthenticated']),
    isAuthenticated() {
      return this.getIsAuthenticated
    }
  },
  created() {
    // 初始化认证状态，只在这里调用一次
    this.$store.dispatch('initAuth')
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  background-color: #f5f5f7;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style> 